import script from "./VerifyStepperModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerifyStepperModal.vue?vue&type=script&setup=true&lang=ts"

import "./VerifyStepperModal.vue?vue&type=style&index=0&id=61d0299d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d0299d"]])

export default __exports__